export default __webpack_public_path__ + "static/media/squirrel.56207376.png";